import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { appRoutes, endpoint } from '@tekman/onmat/constants';
import { StorageService } from '@tekman/shared/service';
import { Observable, of } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class GroupImportGuard implements CanActivate {
  constructor(private readonly _router: Router, private readonly storageService: StorageService) {}

  canActivate(): Observable<boolean> {
    const accessToken = !!(
      this.storageService.getItem('googleAccessToken') || localStorage.getItem(endpoint.external.teamsGraphMeEndpoint)
    );

    if (accessToken) {
      return of(true);
    } else {
      this._router.navigate([`/${appRoutes.groups}`]);
    }
  }
}
